<div class="member">
  <div class="info">
    <div class="link" (click)="memberClickEvent.emit(member())">
      <app-member-avatar [logo]="member().avatar_url" size="small" />

      <div class="title">
        <div class="name">{{ member().username | excerpt: 30 }}</div>

        @if (followedUsersSlice().length) {
          <div class="followed-by">
            <div class="member-avatars">
              @for (followedUser of followedUsersSlice(); track followedUser) {
                <div class="item" [style]="followerStacksStyles(followedUser)"></div>
              }
            </div>
            <div class="text">Your friends follow</div>
          </div>
        }
      </div>
    </div>
  </div>

  @if (showFollowBtn()) {
    <app-follow-button [profile]="member()" size="small" />
  }
</div>
